import { BaseAction } from './BaseAction';
import Locale from '../../utils/Locale';

export class Dosing extends BaseAction {
    public static getTitle:Function = () => Locale.gettext('Chemistry Dosing');
    public static getDescription:Function = () => Locale.gettext('The Attendant is adjusting water chemistry');
}